import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Component } from 'react';
import moment from "moment";
import './Search.css';

class Search extends Component {

  /**
   * Initializes the search component
   * @param props
   */
  constructor(props) {
    super(props);

    let endDate = new Date();
    let endMonth = (((endDate.getMonth() + 1).toString().length === 1) ? `0${endDate.getMonth() + 1}` : endDate.getMonth() + 1);
    let endDay = ((endDate.getDate().toString().length === 1) ? `0${endDate.getDate()}` : endDate.getDate());
    let endTime = `${endDate.getFullYear()}-${endMonth}-${endDay}T23:59:59`;
    let end = moment(endTime);

    let startDate = moment().add(-1, 'days');
    let year = moment(startDate).year();
    let month = moment(startDate).month() + 1;
    let date = moment(startDate).date();
    month = ((month.toString().length === 1) ? `0${month}` : month);
    date = ((date.toString().length === 1) ? `0${date}` : date);

    let startTime = `${year}-${month}-${date}T00:00:00`;
    let timezone = `GMT${this.props.timezone !== '0' ? (this.props.timezone > 0 ? '+' : '') + this.props.timezone + ':00' : ''}`;

    let start = moment(startTime);

    let searchForm = this.props.search;

    if (searchForm) {
      // if (searchForm.convert) {
      //   this.state = {
      //     convert: searchForm.convert,
      //     timezone: timezone,
      //     startTime: moment(moment.utc(searchForm.startTime)).local().format('YYYY-MM-DDTHH:mm:ss'),
      //     endTime: moment(moment.utc(searchForm.endTime)).local().format('YYYY-MM-DDTHH:mm:ss'),
      //     pointInterval: 90,
      //     transmissionInterval: 630
      //   };
      // } else {
      this.state = {
        convert: searchForm.convert,
        timezone: timezone,
        startTime: moment(searchForm.startTime).format('YYYY-MM-DDTHH:mm:ss'),
        endTime: moment(searchForm.endTime).format('YYYY-MM-DDTHH:mm:ss'),
        pointInterval: 90,
        transmissionInterval: 630,
        blockType: 'gap'
      };
      // }
    } else {
      this.state = {
        convert: true,
        timezone: timezone,
        startTime: start.format('YYYY-MM-DDTHH:mm:ss'),
        endTime: end.format('YYYY-MM-DDTHH:mm:ss'),
        pointInterval: 90,
        transmissionInterval: 630,
        blockType: 'gap'
      };
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.timezone !== prevProps.timezone) {
      this.setState({ timezone: `GMT${this.props.timezone !== '0' ? (this.props.timezone > 0 ? '+' : '') + this.props.timezone + ':00' : ''}` });
    }
  }

  /**
   * Change event handler, updates state with changes
   * @async
   * @param event
   * @returns {Promise<void>}
   */
  onChange = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    await this.setState({ [name]: value });
    this.validate();
  };

  /**
   * change event handle for checkboxes, updates state with changes
   * @param event
   */
  onCheckboxChange = (event) => {
    this.setState({ convert: event.target.checked });
  };

  /**
   * Adds a CSS class to an element
   * @param id
   * @param className
   */
  addClass = (id, className) => {
    let element = document.getElementById(id);
    element.classList.add(className);
  };

  /**
   * Removes a CSS class from an element
   * @param id
   * @param className
   */
  removeClass = (id, className) => {
    let element = document.getElementById(id);
    element.classList.remove(className);
  };

  /**
   * Validate the form data and return true if it is valid
   * @returns {boolean}
   */
  validate = () => {
    this.addClass('timeError', 'hidden');
    this.removeClass('startTime', 'form-control-error');
    this.removeClass('endTime', 'form-control-error');

    let errors = 0;

    let start = new Date(this.state.startTime);
    let end = new Date(this.state.endTime);

    if (start > end) {
      this.removeClass('timeError', 'hidden');
      this.addClass('startTime', 'form-control-error');
      this.addClass('endTime', 'form-control-error');
      errors++;
    }

    if (errors === 0) {
      return true;
    } else {
      return false
    }
  };

  /**
   * Submits the form
   */
  onSubmit = () => {
    if (!this.validate()) {
      return;
    }

    if (this.state.convert) {
      let startDate = moment.utc(this.state.startTime).add(-this.props.timezone, 'hours').format('YYYY-MM-DDTHH:mm:ss[Z]');
      let endDate = moment.utc(this.state.endTime).add(-this.props.timezone, 'hours').format('YYYY-MM-DDTHH:mm:ss[Z]');

      this.props.onSearch(this.props.search.serialNumber, startDate, endDate, this.state.convert, this.state.pointInterval, this.state.transmissionInterval, this.state.blockType);
    } else {
      this.props.onSearch(this.props.search.serialNumber, this.state.startTime, this.state.endTime, this.state.convert, this.state.pointInterval, this.state.transmissionInterval, this.state.blockType);
    }
  };

  /**
   * Renders the html for component
   * @returns {*}
   */
  render = () => {
    return (
      <div className={'container'}>
        <div className={'row'}>
          <div className={'col'}>
            <p>All dates are stored in the system as Universal Time Coordinated (UTC). Your current timezone is: {this.state.timezone}</p>
          </div>
        </div>
        <div className={'row '}>
          <div className={'col-4'}>
            <div className={'form-group'}>
              <label htmlFor={'startTime'} className={'form-label'}>Start Time</label>
              <input type={'datetime-local'} id={'startTime'} name={'startTime'}
                className={'form-control'} placeholder={'start time'} step={'1'}
                defaultValue={this.state.startTime} onChange={this.onChange} />
              <div className={'text-danger hidden'} id={'timeError'}>Start Time must be less than End Time.</div>
            </div>
          </div>
          <div className={'col-4'}>
            <div className={'form-group'}>
              <label htmlFor={'endTime'} className={'form-label'}>End Time</label>
              <input type={'datetime-local'} id={'endTime'} name={'endTime'}
                className={'form-control'} placeholder={'end time'} step={'1'}
                defaultValue={this.state.endTime} onChange={this.onChange} />
            </div>
          </div>
          {
            this.props.productType !== 'victim'?
            <div className={'col-4'}>
              <div className={'form-group'} id="pointGroup">
                <label htmlFor={'interval'} className={'form-label'}>GPS Acquisition Gap Size</label>
                <input type={'number'} id={'pointInterval'} name={'pointInterval'} min={'1'}
                  className={'form-control'} placeholder={'minimal interval'}
                  defaultValue={this.state.pointInterval} onChange={this.onChange} />
              </div>
            </div>
            :<div className={'col'}>
              <div className={'form-group'} id="transmissionGroup">
                <label htmlFor={'transmissionInterval'} className={'form-label'}>Heartbeat Gap</label>
                <input type={'number'} id={'transmissionInterval'} name={'transmissionInterval'} min={'1'}
                  className={'form-control'} placeholder={'heartbeat gap (seconds)'}
                  defaultValue={this.state.transmissionInterval} onChange={this.onChange} />
              </div>
            </div>
          }
        </div>
        <div className={'row'}>
          {
            this.props.productType !== 'victim'?
            <div className={'col'}>
              <div className={'form-group'} id="transmissionGroup">
                <label htmlFor={'transmissionInterval'} className={'form-label'}>GPS Transmission Gap Size</label>
                <input type={'number'} id={'transmissionInterval'} name={'transmissionInterval'} min={'1'}
                  className={'form-control'} placeholder={'transmission interval (seconds)'}
                  defaultValue={this.state.transmissionInterval} onChange={this.onChange} />
              </div>
            </div>
            : <div className={'col-4'}>
              <div className={'form-group'}>
                <label htmlFor={'blockType'} className={'form-label'}>Block Type</label>
                <select id={'blockType'} name={'blockType'} className={'form-control'}
                  defaultValue={this.state.filter} onChange={this.onChange}>
                  <option value={'gap'}>Gap Only</option>
                  <option value={'movement'}>Movement Type</option>
                </select>
              </div>
            </div>
          }
          <div className={'col-4'} style={{ alignSelf: 'center' }}>
            {/* <div className={'align-items-center'}>
              <span>UTC Time</span>
              <span className={'form-group align-middle'} style={{ margin: '0.5rem' }}>
                <label htmlFor={'convert'} className={'switch form-label'}>
                  <input type={'checkbox'} id={'convert'} name={'convert'} className={'form-control'}
                    defaultChecked={this.state.convert} onChange={this.onCheckboxChange} />
                  <span className="slider round"></span>
                </label>
              </span>
              <span>Local Time</span>
            </div> */}
          </div>
          <div className={'col-4 align-self-center text-right'}>
            <button className={'btn btn-primary btn-lg'} onClick={this.onSubmit}>Search</button>
          </div>
        </div>
      </div>
    )
  }
}

export default Search;
